/**
 * author by zhang.yingyu
 * createTime 2019-02-28
 */
'use strict';
angular.module("taskSearchMapModule", [])
    .directive("taskSearchMap", ["$timeout", "$q", function($timeout, $q) {
        return {
            restrict: 'AE',
            scope: {
                taskid: "=",
                address: "=",
            },
            templateUrl: './planningCenter/command/directive/taskSearchMap/main_tpl.html',
            link: function($scope, iElement, iAttrs) {
                loadBMap().then(function() {
                    initMap();
                });

                function loadBMap() {
                    var deffer = $q.defer();
                    window.HOST_TYPE = "2";
                    window.BMap_loadScriptTime = (new Date).getTime();
                    LazyLoad.js(["https://api.map.baidu.com/getscript?v=2.0&ak=2OWwHzlWU6jNhRGfjIUZFx7UBZnqgGYl&services=&t=20190123111209"], function() {
                        deffer.resolve();
                    });
                    return deffer.promise;
                    /*var script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = "https://api.map.baidu.com/api?v=2.0&ak=2OWwHzlWU6jNhRGfjIUZFx7UBZnqgGYl";
                    $("head").append(script);*/
                };
                /**
                 * [initMap description] 初始化地图
                 * @return {[type]} [description]
                 */
                function initMap() {
                    $scope.mapContainer = new BMap.Map("map-container");
                    $scope.mapContainer.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
                    $scope.mapContainer.addControl(new BMap.MapTypeControl()); //添加地图类型控件
                    if (angular.isDefined($scope.taskid)) {
                        var point = new BMap.Point($scope.address.value.lng, $scope.address.value.lat);
                        var marker = new BMap.Marker(point);
                        $scope.mapContainer.addOverlay(marker);
                        $scope.mapContainer.centerAndZoom(point, 19);
                    } else {
                        $scope.mapContainer.centerAndZoom("杭州", 12);
                    }
                    var autoComp = new BMap.Autocomplete({
                        "input": "suggest-inp",
                        "location": $scope.mapContainer
                    });
                    autoComp.setInputValue($scope.address.name);
                    //搜索结果绑定hover事件
                    autoComp.addEventListener("onhighlight", function(e) {
                        var str = "",
                            _value, value;
                        if (e.fromitem.index > -1) {
                            _value = e.fromitem.value;
                            value = _value.province + _value.city + _value.district + _value.street + _value.business;
                        }
                        str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
                        if (e.toitem.index > -1) {
                            _value = e.toitem.value;
                            value = _value.province + _value.city + _value.district + _value.street + _value.business;
                        }
                        str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                        $("#searchResultPanel").html(str);
                    });
                    //搜索结果绑定点击事件
                    autoComp.addEventListener("onconfirm", function(e) {
                        var _value = e.item.value;
                        var myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
                        var str = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                        $("#searchResultPanel").html(str);
                        $scope.address.name = myValue;
                        $scope.hiddenSuggestion();
                        setPlace(myValue);
                    });
                }
                /**
                 * [setPlace description] 搜索结果
                 * @param myValue
                 */
                function setPlace(myValue) {
                    $scope.mapContainer.clearOverlays(); //清除地图上所有覆盖物
                    function myFun() {
                        var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
                        $scope.mapContainer.centerAndZoom(pp, 18);
                        $scope.mapContainer.addOverlay(new BMap.Marker(pp)); //添加标注
                        $scope.address.value = pp;
                    }
                    var local = new BMap.LocalSearch($scope.mapContainer, { //智能搜索
                        onSearchComplete: myFun
                    });
                    local.search(myValue);
                }
                /**
                 * [searchAddressData description] 点击按钮搜索
                 * @return {[type]} [description]
                 */
                $scope.searchAddressData = function() {
                    setPlace($scope.address.name);
                };
                /**
                 * [setSearchContent description] 搜索结果内容
                 * @return {[type]} [description]
                 */
                $scope.setSearchContent = function() {
                    var suggestInitHtmlContent = $("body").find(".tangram-suggestion-main").html();
                    $(".search-address-b").find("#search-result-cont").html(suggestInitHtmlContent);
                };
                /**
                 * [hiddenSuggestion description] 隐藏搜索结果
                 * @return {[type]} [description]
                 */
                $scope.hiddenSuggestion = function() {
                    $(".search-address-b").find("#search-result-cont").html("");
                };
            }
        };
    }]);